<template>
  <div class="amazon-image-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div ref="dropzone">
          <input type="hidden" :name="options.name" :id="options.name + '-url'" :value="value"/>
          Choose File(s)
        </div>
        <img class="org-logo" v-show="value"
        :src="imageUrl"
        :width="options.width"
        :height="options.height"/>
        <div class="progress" v-show="isUploading">
          <div class="progress-bar progress-bar-success" role="progressbar"
            :style="{ width: progress + '%' }">
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'AmazonImageInput',
  computed: {
    imageUrl () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      (this.value ? this.value : 'spacer.gif')
    },
    width () {
      return this.options.width + 'px'
    },
    height () {
      return this.options.height + 'px'
    },
    validationClass,
    validationIcon,
    validationMessage
  },
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          width: 100,
          height: 100,
          required: false
        }
      }
    }
  },
  data () {
    return {
      progress: 0,
      isUploading: false,
      isValid: false,
      isDirty: false,
      customError: false
    }
  },
  mounted () {
    window.fd.logging = false
    let zone = new window.FileDrop(this.$refs.dropzone, {
      iframe: {
        url: `/api/admin/image-uploader?width=${this.options.width}&height=${this.options.height}`,
        fileParam: 'image',
        callbackParam: 'iframeCallback'
      }
    })
    let $vm = this
    zone.event('send', function (files) {
      $vm.isUploading = true
      files.each(function (file) {
        $vm.hasError = false
        let uploadErrors = []
        let acceptFileTypes = /^(image\/(gif|jpe?g|png))$/
        if (file.type.length && !acceptFileTypes.test(file.type)) {
          uploadErrors.push('Not an accepted file type')
        }
        if (file.size.length && file.size > 10000000) {
          uploadErrors.push('Filesize is too big')
        }
        if (uploadErrors.length > 0) {
          $vm.hasError = uploadErrors.join('\n')
        } else {
          file.event('progress', function (sent, total, xhr, event) {
            $vm.progress = parseInt(sent / total * 100, 10)
          })
          file.event('done', function (xhr) {
            $vm.progress = 0
            $vm.isUploading = false
            let json = JSON.parse(xhr.responseText)
            $vm.$emit('input', json.key)
          })
          file.event('error', function (xhr) {
            uploadErrors.push(xhr.responseText)
            $vm.hasError = uploadErrors.join('\n')
          })
          file.sendTo(`/api/admin/image-uploader?width=${$vm.options.width}&height=${$vm.options.height}`, {
            extraHeaders: true,
            method: 'POST'
          })
        }
      })
    })
    zone.event('iframeDone', function (json) {
      $vm.progress = 0
      $vm.isUploading = false
      $vm.$emit('input', json.key)
    })
    this.validate(this.value)
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        if (this.options.required) {
          if (val !== '') this.isValid = true
        } else {
          this.isValid = true
        }
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/AmazonImageInput.vue